import React from "react";
import ProfileProgressBarSvg from "./profile-progress-bar-svg";
import './profile-progress-bar.scss';
import { useState } from 'react';
import Modal from '../../components/modal/modal';
import Button from "../../components/UI/Button/Button";

const ProfileProgressBar = (props) => {

    const currentPosition = parseInt(props.currentPosition) || 0;
    const [stateModalOpen, setStateModalOpen] = useState(false);

    // Обязательный курс: один на все уровни и обе роли, всегда последний пункт
    // в каждом списке. Бэкенд — Init::MANDATORY_COURSE_ID / MANDATORY_COURSE_CUP_TIP
    // (essilor-core/api/Init.php). Баллов курс не даёт, поэтому цена в скобках не указана.
    const mandatoryCourseItem = {
        'text' : '<a href="/lk/education/academy">Пройти обязательный курс</a> «Рефракция» в разделе «Обучение. Essilor Академия»*<br/><i>*Курс обязателен для перехода на каждый следующий уровень. Тем участникам, которые прошли данный курс ранее, повторно проходить его не нужно, кубок будет присвоен автоматически.</i>',
        'html' : true
    };

    const consultantList = {
        'specialist' : [
            {
                'text' : 'Набрать 2 030 баллов',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/upload-sales-consultant">Внести продажи</a> не менее, чем на 1 500 баллов',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти курс "Быстрый старт"</a> или тест по курсу "Быстрый старт" в разделе "Обучение. Essilor Академия"(300 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/trainer/course/uskorenie-prodazh-turbo-sales">Просмотреть видеозапись вебинара</a> от бизнес-тренера «Ускорение продаж. Turbo Sales» (150 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Просмотреть</a> два федеральных вебинара от Академии Essilor онлайн (20 баллов)',
                'html' : true
            },
            {
                'text' : 'Воспользоваться разделом «Подбиратор» не менее одного раза (35 баллов)',
                'html' : ''
            },
            {
                'text' : 'Воспользоваться разделом «Библиотека знаний» не менее 5 раз (25 баллов)',
                'html' : ''
            },
            mandatoryCourseItem
        ],
        'professional' : [
            {
                'text' : 'Набрать 10 480 баллов',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/upload-sales-consultant">Внести продажи</a> не менее, чем на 9000 баллов',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти курс</a> "Essilor Профессионал" (450 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/library?brand=varilux&section=webinar_records">Пройти обучение</a> по теме «Работа с Eye-ruler 2» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Посмотреть</a> 7 любых федеральных вебинаров онлайн (по 10 баллов за каждый просмотренный вебинар)',
                'html' : true
            },
            {
                'text' : 'Воспользоваться разделом «Подбиратор» не менее 5 раз (25 баллов)',
                'html' : ''
            },
            {
                'text' : 'Воспользоваться разделом «Библиотека знаний» не менее 5 раз (5 баллов)',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/library?brand=varilux&section=sale_script">Использовать</a> в работе файл «Коммуникации с покупателем»',
                'html' : true
            },
            mandatoryCourseItem
        ],
        'expert' : [
            {
                'text' : 'Набрать 13 680 баллов',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/upload-sales-consultant">Внести ключевые продажи</a>, не менее 8 пар:<ul><li>4 пары Varilux Comfort Max, 2 пары из них с технологией Transitions (8 линз)</li><li>4 пары Crizal Eyezen, 2 пары из них с технологией Transitions (8 линз)</li></ul><i>*Вам доступна новая шкала баллов, для отслеживания прогресса по ключевым продажам</i>',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Эффективные коммуникации для успешных продаж» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Дополнительные возможности производства» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Особенности посадки оправы на конкретном покупателе. Измерение параметров посадки» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Ценность премиальных решений Essilor за 5 минут» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «7 простых шагов к легкой адаптации к мультифокусным линзам» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти курс</a> «Клиентоориентированный сервис» в разделе «Обучение. Essilor Академия» (100 баллов)**<br/><i>**Тем участникам, которые прошли данный курс ранее, повторно проходить его не нужно, баллы и кубок будут присвоены автоматически.</i>',
                'html' : true
            },
            mandatoryCourseItem
        ],
        'expertAdditionalWithoutCup' : [

        ],
        'expertAdditional' : [
            // {
            //     'text' : 'Просмотр видеозаписи «10 советов для успешного подбора МФЛ» в новом разделе Essilor Академия - «Учебные материалы»',
            //     'html' : ''
            // },
            // {
            //     'text' : 'Просмотр вебинара «Сложные случаи подбора МФЛ (тех.)» в новом разделе Essilor Академия - «Учебные материалы»',
            //     'html' : ''
            // },
            // {
            //     'text' : 'Просмотр вебинара «Сложные случаи подбора МФЛ (мед.)» в новом разделе Essilor Академия - «Учебные материалы»',
            //     'html' : ''
            // },
            {
                'text' : '<a href="/lk/education/academy?type=records">Просмотр вебинара</a> «Однофокальные линзы Essilor F-360..(Керник Н.Ю.)» в новом разделе Essilor Академия - «Записи вебинаров»',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy?type=records">Просмотр вебинара</a> «Персонализация МФЛ: кому? когда? зачем? ( О.Кольцова)» в новом разделе Essilor Академия - «Записи вебинаров»',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy?type=records">Просмотр вебинара</a> «Искусство задавать вопросы» в новом разделе Essilor Академия - «Записи вебинаров»',
                'html' : true
            },
            {
                'text' : '<a href="/lk/library">10 новых видео по теме</a> «Ценность премиальных решений Essilor за 5 минут» в разделе - «Библиотека знаний»',
                'html' : true
            }
        ]
    }
    const doctorList = {
        'specialist' : [
            {
                'text' : 'Набрать 2 030 баллов',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/upload-sales-doctor">Внести продажи</a> не менее, чем на 1 500 баллов',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти курс "Фокус на Varilux"</a> или тест по курсу " Фокус на Varilux " в разделе "Обучение. Essilor  Академия"(300 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/trainer/course/uskorenie-prodazh-turbo-sales">Просмотреть видеозапись вебинара</a> от бизнес-тренера «Ускорение продаж. Turbo Sales» (150 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Просмотреть</a> два федеральных вебинара от Академии Essilor онлайн (20 баллов)',
                'html' : true
            },
            {
                'text' : 'Воспользоваться разделом «Подбиратор» не менее одного раза (35 баллов)',
                'html' : ''
            },
            {
                'text' : 'Воспользоваться разделом «Библиотека знаний» не менее 5 раз (25 баллов)',
                'html' : ''
            },
            mandatoryCourseItem
        ],
        'professional' : [
            {
                'text' : 'Набрать 10 480 баллов',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/upload-sales-doctor">Внести продажи</a> не менее, чем на 9000 баллов',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти курс</a> "Essilor Профессионал" (450 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/library?brand=varilux&section=webinar_records">Пройти обучение</a> по теме «Работа с Eye-ruler 2» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Посмотреть</a> 7 любых федеральных вебинаров онлайн (по 10 баллов за каждый просмотренный вебинар)',
                'html' : true
            },
            {
                'text' : 'Воспользоваться разделом «Подбиратор» не менее 5 раз (25 баллов)',
                'html' : ''
            },
            {
                'text' : 'Воспользоваться разделом «Библиотека знаний» не менее 5 раз (5 баллов)',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/library?brand=varilux&section=sale_script">Использовать</a> в работе файл «Коммуникации с покупателем»',
                'html' : true
            },
            mandatoryCourseItem
        ],
        'expert' : [
            {
                'text' : 'Набрать 13 680 баллов',
                'html' : ''
            },
            {
                'text' : '<a href="/lk/upload-sales-doctor">Внести ключевые продажи</a>, не менее 8 пар:<ul><li>4 пары Varilux Comfort Max, 2 пары из них с технологией Transitions (8 линз)</li><li>4 пары Crizal Eyezen, 2 пары из них с технологией Transitions (8 линз)</li></ul><i>*Вам доступна новая шкала баллов, для отслеживания прогресса по ключевым продажам</i>',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Эффективные коммуникации для успешных продаж» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Дополнительные возможности производства» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Исследование аккомодации и бинокулярного зрения» в разделе «Обучение. Essilor Академия» (100 баллов) ',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «Ценность премиальных решений Essilor за 5 минут» в разделе «Обучение. Essilor Академия» (100 баллов)</b>',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти новый курс</a> «7 простых шагов к легкой адаптации к мультифокусным линзам» в разделе «Обучение. Essilor Академия» (100 баллов)</b>',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy">Пройти курс</a> «Клиентоориентированный сервис» в разделе «Обучение. Essilor Академия» (100 баллов))**<br/><i>**Тем участникам, которые прошли данный курс ранее, повторно проходить его не нужно, баллы и кубок будут присвоены автоматически.</i>',
                'html' : true
            },
            mandatoryCourseItem
        ],
        'expertAdditionalWithoutCup' : [
            {
                'text' : '<a href="/lk/education/academy">Новый курс</a> «Особенности посадки оправы на конкретном покупателе. Измерение параметров посадки» в разделе «Обучение. Essilor Академия» (100 баллов)',
                'html' : true
            }
        ],
        'expertAdditional' : [
            // {
            //     'text' : 'Просмотр видеозаписи «10 советов для успешного подбора МФЛ» в новом разделе Essilor Академия - «Учебные материалы»',
            //     'html' : ''
            // },
            // {
            //     'text' : 'Просмотр вебинара «Сложные случаи подбора МФЛ (тех.)» в новом разделе Essilor  Академия - «Учебные материалы»',
            //     'html' : ''
            // },
            {
                'text' : '<a href="/lk/education/academy?type=records">Просмотр вебинара</a> «Однофокальные линзы Essilor F-360..(Керник Н.Ю.)» в новом разделе Essilor Академия - «Записи вебинаров»',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy?type=records">Просмотр вебинара</a> «Персонализация МФЛ: кому? когда? зачем? ( О.Кольцова)» в новом разделе Essilor Академия - «Записи вебинаров»',
                'html' : true
            },
            {
                'text' : '<a href="/lk/education/academy?type=records">Просмотр вебинара</a> «Искусство задавать вопросы» в новом разделе Essilor Академия - «Записи вебинаров»',
                'html' : true
            },
            {
                'text' : '<a href="/lk/library">10 новых видео по теме</a> «Ценность премиальных решений Essilor за 5 минут» в разделе - «Библиотека знаний»',
                'html' : true
            }
        ]
    }
    const specialistList = props.roleCode !== 'DOCTOR_USERS'
        ? consultantList.specialist
        : doctorList.specialist;
    const professionalList = props.roleCode !== 'DOCTOR_USERS'
        ? consultantList.professional
        : doctorList.professional;
    const expertList = props.roleCode !== 'DOCTOR_USERS'
        ? consultantList.expert
        : doctorList.expert;
    const expertAdditionalList = props.roleCode !== 'DOCTOR_USERS'
        ? consultantList.expertAdditional
        : doctorList.expertAdditional;
    const expertAdditionalListWithoutCup = props.roleCode !== 'DOCTOR_USERS'
        ? consultantList.expertAdditionalWithoutCup
        : doctorList.expertAdditionalWithoutCup;

    if (currentPosition === 0) {
        return '';
    }

    return (
        <>
            <div className="font-semibold text-xl mb-3">
                <span className="title-semibold title-semibold__black">Прогресс</span>
                <span onClick={() => setStateModalOpen(true)} className="icon-info ml-2 cursor-pointer text-essilor-light-blue"></span>
                <div className="text-xs text-essilor-gray font-normal underline">Информация об уровнях</div>
            </div>

            <div className="profile-progress-bar-wrapper">

                <ProfileProgressBarSvg width={props.width} currentPosition={currentPosition}/>

                <div className={`profile-progress-bar ${props.width < 730 ? `sm` : ``}`}>
                    <div className={currentPosition === 1 ? `active` : ``}>
                        <b>1</b>
                        <span>Уровень<i className="dash"> - </i><strong>Специалист</strong><i className="icon-check-mark"/>
                                                    <i className="mark-point">Вы здесь</i>
                                                </span>

                    </div>
                    <div className={currentPosition === 1 ? `inactive` : (currentPosition === 2 ? `active` : ``)}>
                        <b>2</b>
                        <span>Уровень<i className="dash"> - </i><strong>Профессионал</strong><i className="icon-check-mark"/>
                                                    <i className="mark-point">Вы здесь</i>
                                                </span>
                    </div>
                    <div className={currentPosition === 3 ? `active` : `inactive`}>
                        <b>3</b>
                        <span>Уровень<i className="dash"> - </i><strong>Эксперт</strong><i className="icon-check-mark"/>
                                                    <i className="mark-point">Вы здесь</i>
                                                </span>
                    </div>
                </div>

            </div>

            <Modal isOpen={stateModalOpen} onClose={() => setStateModalOpen(false)} hideCloseButton={true}
                   boxStyle={{maxWidth: '65rem'}}>
                <div className="profile-progress-bar-modal text-center">
                    <h2 className="title-semibold title-semibold__black">Разделы и баллы</h2>

                    <p className="text-left mt-4">
                        <b>Для перехода на уровень «Профессионал», Вам необходимо:</b>
                        <ul>
                            {
                                specialistList.map((item) => {
                                    return item.html
                                        ? <li className="mb-1" dangerouslySetInnerHTML={{ __html: " → " + item.text }} />
                                        : <li className="mb-1"> &mdash; {item.text}</li>
                                })
                            }
                        </ul>
                    </p>

                    <p className="text-left mt-4">
                        <b>Для перехода на уровень «Эксперт», Вам необходимо:</b>
                        <ul>
                            {
                                professionalList.map((item) => {
                                    return item.html
                                        ? <li className="mb-1" dangerouslySetInnerHTML={{ __html: " → " + item.text }} />
                                        : <li className="mb-1"> &mdash; {item.text}</li>
                                })
                            }
                        </ul>
                    </p>

                    <p className="text-left mt-4">
                        <b>На уровне «Эксперт», Вам необходимо:</b>
                        <ul>
                            {
                                expertList.map((item) => {
                                    return item.html
                                        ? <li className="mb-1" dangerouslySetInnerHTML={{ __html: " → " + item.text }} />
                                        : <li className="mb-1"> &mdash; {item.text}</li>
                                })
                            }
                        </ul>

                        { expertAdditionalListWithoutCup.length > 0 &&
                            <>
                                <b>Дополнительно, без начисления кубка, Вам доступен следующий курс:</b>
                                <ul>
                                {
                                    expertAdditionalListWithoutCup.map((item) => {
                                        return item.html
                                            ? <li className="mb-1" dangerouslySetInnerHTML={{ __html: " → " + item.text }} />
                                            : <li className="mb-1"> &mdash; {item.text}</li>
                                    })
                                }
                                </ul>
                            </>
                        }

                        <b>Дополнительно, без начисления баллов и кубков, Вам доступны следующие материалы для просмотра:</b>
                        <ul>
                            {
                                expertAdditionalList.map((item) => {
                                    return item.html
                                        ? <li className="mb-1" dangerouslySetInnerHTML={{ __html: " → " + item.text }} />
                                        : <li className="mb-1"> &mdash; {item.text}</li>
                                })
                            }
                        </ul>
                    </p>

                    <Button className="btn btn-blue btn-narrow w-56 mt-10" style={{fontWeight: 'normal'}}
                            onClick={() => setStateModalOpen(false)}>Понятно</Button>
                </div>
            </Modal>
        </>



    )
};

export default ProfileProgressBar;
